import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Route guard for manager and above roles.
 * Allows: developer, superuser, owner, admin, manager
 * Denies: user (and any other role)
 */
function ManagerRoute({ children }) {
  const { currentUser, userRole, loading } = useAuth();

  // Still loading auth state
  if (loading) {
    return <div>Loading...</div>;
  }

  // Not logged in at all
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Check if user is manager or above
  const isManagerOrAbove = ['developer', 'superuser', 'owner', 'admin', 'manager'].includes(userRole);

  // Logged in but not manager or above
  if (!isManagerOrAbove) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '50vh',
        padding: '20px'
      }}>
        <h2>Access Denied</h2>
        <p>You need manager privileges or above to access this page.</p>
        <button
          onClick={() => window.history.back()}
          style={{
            marginTop: '20px',
            padding: '10px 20px',
            backgroundColor: '#2196F3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Go Back
        </button>
      </div>
    );
  }

  // Is manager or above - allow access
  return children;
}

export default ManagerRoute;
